import { useRef } from 'react';
import CHECKBOX_STATES from '../../../constants/checkBoxTypes';
import { useEffect } from 'react';

export const Checkbox = ({ label, value, onChange, disabled }) => {
  const checkboxRef = useRef();

  useEffect(() => {
    if (value === CHECKBOX_STATES.Checked) {
      checkboxRef.current.checked = true;
      checkboxRef.current.indeterminate = false;
    } else if (value === CHECKBOX_STATES.Empty) {
      checkboxRef.current.checked = false;
      checkboxRef.current.indeterminate = false;
    } else if (value === CHECKBOX_STATES.Indeterminate) {
      checkboxRef.current.checked = false;
      checkboxRef.current.indeterminate = true;
    }
  }, [value]);

  return (
    <div className={'checkbox-innerWrapper'}>
      <label>
        <input disabled={disabled} ref={checkboxRef} type='checkbox' onChange={onChange} />
        {label}
      </label>
    </div>
  );
};
